import angular from 'angular';

module.exports = angular.module('common.filters.listing-display-address', [])
.filter('listingDisplayAddress', function() {
  return function(listing) {
    if (listing.flip_state === 'contingencies_released') {
      return listing.address.street.replace(/^\d+/, '').replace(/#.*$/, '');
    } else {
      return listing.address.street;
    }
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/listing-display-address.js
 **/